module.exports = __webpack_public_path__ + "static/media/CrushedCorner_Before.7232bf06.jpg";